import { getCorrectStrTime } from './getCorrectStrTime';

export const getTimeFromMinutes = (minutes: number) => {
  const hour = Math.trunc(minutes / 60);
  const correctMinutes = minutes - hour * 60;

  return `${getCorrectStrTime(hour)}:${getCorrectStrTime(correctMinutes)}:00`;
};
